import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  sendRegistrationData,
  sendRegistrationDataLkm,
} from 'feature/registration/sendRegistrationData'
import {
  RegistrationData,
  RegistrationLkmData,
} from 'feature/registration/types'
import { RootState } from 'store/types'

import { AuthStatus, authActions } from '../authSlice'

// регистрация пользователя (только для новых пользователей)
export const doRegistration = createAsyncThunk<
  void,
  RegistrationData,
  { state: RootState }
>('auth/doRegistration', (data, { dispatch }) => {
  dispatch(authActions.setAuthInfo({ isLoading: true }))
  sendRegistrationData(data)
    .then(() => {
      dispatch(authActions.setAuthInfo({ status: AuthStatus.registered }))
    })
    .finally(() => dispatch(authActions.setAuthInfo({ isLoading: false })))
})

export const doRegistrationLkm = createAsyncThunk<
  void,
  RegistrationLkmData,
  { state: RootState }
>('auth/doRegistrationLkm', (data, { dispatch }) => {
  dispatch(authActions.setAuthInfo({ isLoading: true }))
  sendRegistrationDataLkm(data)
    .then(() => {
      dispatch(authActions.setAuthInfo({ status: AuthStatus.registered }))
    })
    .finally(() => dispatch(authActions.setAuthInfo({ isLoading: false })))
})
